'use client'

import { useEffect } from 'react'
import ErrorPage from './ErrorPage/ErrorPage'
import * as Sentry from "@sentry/nextjs";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Log the error to your error reporting service
    Sentry.captureException(error);
  }, [error])
 
  return (
    
    <ErrorPage code={500} message={"Something went wrong!"}
    action={{
        text: "Try again",
        onClick: reset
      }}/>

  )
}